/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Dirs_Table_ModifiedInputs */

const es_settings_dirs_table_modified = /** @type {(inputs: Settings_Dirs_Table_ModifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modificado`)
};

const en_settings_dirs_table_modified = /** @type {(inputs: Settings_Dirs_Table_ModifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modified`)
};

/**
* | output |
* | --- |
* | "Modified" |
*
* @param {Settings_Dirs_Table_ModifiedInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const settings_dirs_table_modified = /** @type {((inputs?: Settings_Dirs_Table_ModifiedInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Dirs_Table_ModifiedInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_dirs_table_modified(inputs)
	return en_settings_dirs_table_modified(inputs)
});
export { settings_dirs_table_modified as "settings.dirs.table.modified" }